import { parse, stringify } from 'query-string';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';

const useQueryString = (parseOptions, stringifyOptions) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [state, setState] = useState(parse(location.search, parseOptions));

    const setQuery = (values) => {
        const newQuery = {
            ...state,
            ...values,
        };

        setState(newQuery);
        navigate({ search: '?' + stringify(newQuery, stringifyOptions) });
    };

    return [state, setQuery];
};

export default useQueryString;
